<template>
  <div class="configManageUserVue">
    <div class="col-md-10 col-sm-9 u-pad-all-25 c-common-box-shadow u-bg-color-fff">
        <!-- Manage Powerusers -->
        <div class="manage-powerusers">

            <h3 class="u-cmn-botmargin">Manage Auditor Users <span class="c-common-btn--inverse-icon-orange"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span></h3>

            <div class="row">
                <div class="col-sm-12">
                    <div class="text-center">
                        <ul class="o-filter-area notic-ul-item o-instruction-text">
                            <li  class="notic-li-item">
                                <span class="req-text">* </span>
                                <span>Granting auditor rights will remove the ability of the user to NOT confirm or decline offers of work.</span>
                            </li> 
                            <li class="notic-li-item">
                                <span class="req-text">* </span>
                                <span>Please create and Institutional Email for assigning Auditor Access.</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="o-manageusers-checkbox c-margin-bottom-10">
                        <div class="manageusers-checkbox-head clearfix">
                            <div class="row">
                                <div class="col-md-6">
                                <h4>Active Auditor User list:</h4>
                                <div class="o-subtitleHeading">
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            <input type="checkbox" name="o4"  v-model="selectType" @change="selectAll()">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                    <label class="o-blue-regular-text">Select All:</label>

                                </div>
                            </div>
                            <div class="col-md-6 text-right">
                                <a href="javascript: void(0)" @click="removePowerUser()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete</a>
                            </div>
                            </div>


                        </div>
                        <div class="manageusers-checkbox-body clearfix">
                            <div class="manageusers-checkbox-body-inner">
                                <div v-for="powerUsers in powerUsersList" class="col-sm-6 o-powerUser-list">
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            {{powerUsers.first_name+" "+powerUsers.last_name}}
                                            <input type="checkbox" name="o4" :value="powerUsers.id" checked="" v-model="selectedPowerUser">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </div>
                                <!-- <div class="col-sm-6">
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            CN Admin
                                            <input type="checkbox" name="o4" value="" checked="">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="addnewpoweruser">
                      <h4>Add New Auditor User form:</h4>
                        <div class="o-cutsomSelect o-cutsomSelect--poweruser o-multiselect-drop">

<!--
                            <select class="o-multiselect" multiple v-model="selectedSteward">
                                <option value="">--- Select ---</option>
                                <option v-for="steward in stewardList" :value="steward.id">{{steward.first_name+" "+steward.last_name}}</option>
                            </select>
-->

                            
                            
                            <el-select
                                v-model="selectedSteward"
                                filterable
                                remote
                                reserve-keyword
                                multiple
                                collapse-tags
                                style="width: 100%;"
                                placeholder="Select">
                                <el-option
                                  v-for="steward in stewardList"
                                  :key="steward.id"
                                  :label="steward.first_name + ' ' + steward.last_name"
                                  :value="steward.id">
                                </el-option>
                              </el-select>
                        </div>
                        <div class="clearfix"></div>
                        <a href="javascript: void(0)" @click="promoteStewards()" class="c-solid-btn c-solid-btn--green">Promote</a>
                    </div>

                </div>

            </div>
</div>
        <!-- Manage Powerusers -->
    </div>
  </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';
    import service from '../../services.js';
    export default {
        data() {
            return {
                powerUsersList: [],
                stewardList: [],
                selectedSteward: [],
                selectedPowerUser: [],
                selectType: 0

            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            })
        },
        methods: {
            promoteStewards() {
                if (this.selectedSteward.length != 0) {
                    service.post('employee/promoteToAuditorUser', {
                            'employee_id': JSON.stringify(this.selectedSteward)
                        }, {
                            'Authorization': this.userToken,
                            'clientId':this.userClientID,
                        })
                        .then((res) => {
                            this.getInitialData();
                            this.selectedSteward = [];

                        }).catch((err) => {
                            console.log(err);
                        });
                }
            },
            removePowerUser() {
                if (this.selectedPowerUser.length != 0) {
                    service.post('employee/removeFromAuditorUser', {
                            'employee_id': JSON.stringify(this.selectedPowerUser)
                        }, {
                            'Authorization': this.userToken,
                            'clientId':this.userClientID,
                        })
                        .then((res) => {
                            this.getInitialData();

                        }).catch((err) => {
                            console.log(err);
                        });
                }
            },
            getInitialData() {
                service.get('employee/getAuditorUsers', {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.userClientID,
                    })
                    .then((res) => {
                        this.powerUsersList = res.data.result;
                        //console.log('powerUsersList', this.powerUsersList);

                    }).catch((err) => {
                        console.log(err);
                    });

                // Get steward list
                service.get('employee/otherUsers', {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.userClientID,
                    })
                    .then((res) => {
                        this.stewardList = res.data.result;
                        //console.log('stewardList', this.stewardList);
                        $('#example-getting-started').multiselect();

                    }).catch((err) => {
                        console.log(err);
                    });
            },
            selectAll() {


                this.selectedPowerUser = [];
                if (this.selectType == true) {
                    for (var i = 0; i < this.powerUsersList.length; i++) {
                        this.selectedPowerUser.push(this.powerUsersList[i].id);
                    }
                }
                //console.log(this.selectedPowerUser);

            }
        },
        mounted() {

        },
        created() {
            // Get Power user list
            this.getInitialData();
        }

    }

</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/configuration/configManageAuditor.vue